import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { OverviewChart } from "components";

const Overview = () => {
  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Overview</h1>
          <p className="text-muted-foreground">
            Overview of sales and performance metrics.
          </p>
        </div>
        <Select defaultValue="sales">
          <SelectTrigger className="w-32">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="sales">Sales</SelectItem>
            <SelectItem value="units">Units</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Sales Overview</CardTitle>
          <CardDescription>
            View overall sales performance and trends.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="h-96">
            <OverviewChart view="sales" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Overview;
